export const getModleImageClassName = (item, selectedImageId, isSelecting) => {
	return `single-img ${!isSelecting ? 'cursor-pointer' : ''} ${
		parseInt(selectedImageId) === parseInt(item?.documentResponse?.id) ? 'active' : ''
	}`;
};
